/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verified_PurchaseInputs */

const en_verified_purchase = /** @type {(inputs: Verified_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified Purchase`)
};

const es_verified_purchase = /** @type {(inputs: Verified_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compra verificada`)
};

const fr_verified_purchase = /** @type {(inputs: Verified_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achat vérifié`)
};

const de_verified_purchase = /** @type {(inputs: Verified_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifizierter Kauf`)
};

const ja_verified_purchase = /** @type {(inputs: Verified_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認済みの購入`)
};

const zh_verified_purchase = /** @type {(inputs: Verified_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已验证购买`)
};

const ar_verified_purchase = /** @type {(inputs: Verified_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شراء معتمد`)
};

const id_verified_purchase = /** @type {(inputs: Verified_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembelian Terverifikasi`)
};

const it_verified_purchase = /** @type {(inputs: Verified_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquisto Verificato`)
};

const ru_verified_purchase = /** @type {(inputs: Verified_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвержденная покупка`)
};

const pt_verified_purchase = /** @type {(inputs: Verified_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compra Verificada`)
};

const ko_verified_purchase = /** @type {(inputs: Verified_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증된 구매`)
};

/**
* | output |
* | --- |
* | "Verified Purchase" |
*
* @param {Verified_PurchaseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verified_purchase = /** @type {((inputs?: Verified_PurchaseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verified_PurchaseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verified_purchase(inputs)
	if (locale === "es") return es_verified_purchase(inputs)
	if (locale === "fr") return fr_verified_purchase(inputs)
	if (locale === "de") return de_verified_purchase(inputs)
	if (locale === "ja") return ja_verified_purchase(inputs)
	if (locale === "zh") return zh_verified_purchase(inputs)
	if (locale === "ar") return ar_verified_purchase(inputs)
	if (locale === "id") return id_verified_purchase(inputs)
	if (locale === "it") return it_verified_purchase(inputs)
	if (locale === "ru") return ru_verified_purchase(inputs)
	if (locale === "pt") return pt_verified_purchase(inputs)
	return ko_verified_purchase(inputs)
});